export default __webpack_public_path__ + "static/media/story_otomo-8.387aae40.png";